import { isValid } from 'date-fns';

/** Parses API / form values into a valid Date, or undefined when not parseable. */
export const toValidDate = (value: unknown): Date | undefined => {
  if (value instanceof Date) {
    return isValid(value) ? value : undefined;
  }
  if (typeof value === 'string' || typeof value === 'number') {
    const parsed = new Date(value);
    return isValid(parsed) ? parsed : undefined;
  }
  return undefined;
};
